import React from 'react'

export default function usePagination(total: number, perPage: number) {
    const pagination = Math.ceil(total / perPage)
    const arrayPagination = Array.from(Array(pagination), (_, index) => index)

    return {countPagination: arrayPagination, showPagination: total > perPage}
}
